

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

define(function (require, exports, module) {

    /**
     * @file 组件基类
     * @authors 子虔
     * @date    2014-05-12 17:39:36
     * @example <caption>扩展一个子类</caption>
     *      Base.extend({
     *          defaults: {}, // 设置类的默认参数
     *          constructor: function Widget(){
     *              // 子类的构造函数
     *          },
     *      });
     *
     */
    var Events = require('./events'),
        extend = require('./extend'),
        attributes = require('./attributes'),
        isEqual = require('./is-equal'),
        parseParam = require('./parse-param');

    /**
     * 组件Base类
     * @param {object} [Opts={}] - 入参
     */
    function Base(Opts) {
        // 默认配置
        this.defaults = this.defaults || {};

        // 用户配置
        this.config = Opts || {};

        // 最终配置
        this.attributes = $.extend({}, this.attributes || {}, this.defaults) || {};

        if (_typeof(this.config) == 'object') {
            this.attributes = $.extend(this.attributes, this.config) || {};
        }

        this.initialize.apply(this, arguments);
    }

    // 扩展
    $.extend(Base.prototype, Events, {
        /**
         * @constructs
         */
        constructor: Base,

        initialize: function initialize() {},

        /**
         * 频道
         * @deprecated - 当要被废弃
         */
        channel: Events.channel,

        /**
         * 获取配置
         * @param  {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            return this.attributes[name];
        },

        /**
         * 设置配置
         * @param {*} name  -属性名
         * @param {*} [value] [属性值]
         * @param {boolean} [silent=false] [变化时是否派发事件，默认派发]
         */
        set: function set(name, value, silent) {
            var lastValue;
            if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) == 'object') {
                silent = value;
                for (var key in name) {
                    if (name.hasOwnProperty(key)) {
                        this.set(key, name[key], silent);
                    }
                }
            } else {
                lastValue = this.attributes[name];
                this.attributes[name] = value;
                if (!silent && !isEqual(lastValue, value)) {
                    this.emit('change:' + name, value, lastValue);
                    this.emit('change');
                }
            }
        },

        /**
         * 重置配置
         * @param  {string[]} [whiteList=[]] - white list,不需要重置的list
         * @param  {boolean} [silent=false] - 是否不不派发事件
         */
        reset: function reset(whiteList, silent) {
            whiteList = whiteList || [];

            if (arguments.length > 1) {
                silent = !!whiteList;
            }

            this.defaults = this.defaults || {};

            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key) && whiteList.indexOf(key) == -1) {
                    this.set(key, this.defaults[key], silent);
                }
            }
        },
        /**
         * 销毁，默认移除事件
         */
        destroy: function destroy() {
            this.off();
        }
    });

    // 生成子类
    Base.extend = extend;

    // 修改原型
    Base.use = function (protoProps) {
        var that = this,
            protoProps = [].concat(protoProps);

        protoProps.forEach(function (proto) {
            for (var name in proto) {
                if (proto.hasOwnProperty(name)) {
                    that.prototype[name] = proto[name];
                }
            }
        });
        return this;
    };

    // 组件过滤参数
    Base.parseParam = function (protoProps) {
        var newBase;

        newBase = this.extend({
            /**
             * 过滤实例时的参数
             * @description 剔除非defaults定义的属性
             */
            initialize: function initialize() {
                this.attributes = parseParam(this.defaults || {}, this.attributes);
                this.Parent(initialize, arguments);
            }
        });

        return protoProps ? newBase.extend(protoProps) : newBase;
    };

    module.exports = Base.extend(attributes);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-base/dist/index.js
// module id = 715
// module chunks = 0